export default (state = [], action) => {
  let newComments = [...state]
  switch (action.type) {
    case 'SET_COMMENTS':
      newComments = [...action.payload]
      break
    case 'ADD_COMMENT':
      const newComment = action.payload
      const newIndex = newComments.findIndex(comment => comment.milliseconds > newComment.milliseconds)
      if (newIndex === -1) newComments.push(newComment)
      else newComments.splice(newIndex, 0, newComment)
      break;
  }

  return newComments
}